import { Box, Checkbox, Typography } from "@mui/material";
import { IHeaderParams } from "ag-grid-community";

type Props = IHeaderParams & {
  isAllSelected: boolean;
  isIndeterminate: boolean;
  onToggleAll: (checked: boolean) => void;
};

const HeaderSelectAll = (props: Props) => {
  const { isAllSelected, isIndeterminate, onToggleAll, displayName } = props;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Checkbox
        // size="small"
        sx={{ p: 0 }}
        checked={isAllSelected}
        indeterminate={isIndeterminate}
        onChange={(e) => onToggleAll(e.target.checked)}
      />
      {displayName && (
        <Typography fontSize={14} fontWeight={600} lineHeight={1.2}>
          {displayName}
        </Typography>
      )}
    </Box>
  );
};

export default HeaderSelectAll;
